import"./lit-html.js";/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const o=s=>s.strings===void 0,t={},m=(s,i=t)=>s._$AH=i;export{o as isSingleExpression,m as setCommittedValue};
